import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { DefaultState, createFetchReducer, defaultInitialState } from 'store/setLocalStore';
import * as Actions from '../actions';
import { AttachmentUploadResponseInterface, UserInsuranceInfo } from '../types';

export interface EVisitInsuranceSessionState {
  eVisit: EVisitSessionState;
  insuranceSummary: DefaultState<UserInsuranceInfo>;
  sendInsurance: DefaultState<AttachmentUploadResponseInterface>;
}

export interface EVisitSessionState {
  eVisitState: string;
  eVisitSessionToken: string;
  isEVisitFrontDoor?: boolean;
  isFetching?: boolean;
  error?: boolean;
}

export const defaultEVisitState: EVisitSessionState = {
  eVisitState: '',
  eVisitSessionToken: '',
  isEVisitFrontDoor: false,
  isFetching: false,
  error: false
};

export const defaultInsuranceSessionState = {
  eVisit: defaultEVisitState,
  insuranceSummary: defaultInitialState(),
  sendInsurance: defaultInitialState()
};

const eVisit = createReducer(defaultEVisitState, {
  [Actions.START_E_VISIT]: state => {
    state.isFetching = true;
    state.error = false;
  },
  [Actions.START_E_VISIT_FAIL]: state => {
    state.isFetching = false;
    state.error = true;
  },
  [Actions.START_E_VISIT_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.eVisitState = action.payload;
  },
  [Actions.SET_E_VISIT_SESSION_TOKEN]: (state, action) => {
    state.eVisitSessionToken = action.payload.token;
    state.isEVisitFrontDoor = action.payload.options?.isFrontDoor || false;
  },
  [Actions.RESET_E_VISIT_SESSION_TOKEN]: state => {
    state.eVisitSessionToken = '';
    state.isEVisitFrontDoor = false;
    state.error = false;
  },
  [Actions.CHECK_E_VISIT_ELIGIBILITY_SUCCESS]: state => {
    state.eVisitSessionToken = '';
    state.isEVisitFrontDoor = false;
    state.error = false;
  }
});

export default combineReducers({
  eVisit,
  insuranceSummary: createFetchReducer<UserInsuranceInfo>(Actions.CHECK_E_VISIT_SUMMARY),
  sendInsurance: createFetchReducer(Actions.SEND_E_VISIT_INSURANCE)
});
